"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordConfirmInput = void 0;
/**
 * Provides a password input and a password confirmation field.
 * If the two fields are identical the string will be returned. If the two fields are not identical an empty string will be returned
 */
const React = require("react");
const _ = require("lodash");
const PasswordInput_1 = require("../PasswordInput");
class PasswordConfirmInput extends React.Component {
    constructor(props) {
        super(props);
        this.passwordFieldChange = (key, value) => {
            this.setState({ [key]: value }, this.informParentThroughCallback);
        };
        this.checkBothFieldsArePopulated = () => {
            const isMissing = _.keys(this.state).filter(n => !this.state[n]).length > 0;
            return !isMissing ? this.confirmPasswordMatches() : null;
        };
        this.confirmPasswordMatches = () => {
            return this.state.password === this.state.confirmPassword
                ? this.state.password
                : null;
        };
        this.informParentThroughCallback = () => {
            // Avoid responding to out own update to avoid clearing all fields in some circumstances
            this.props.onInputChange(this.checkBothFieldsArePopulated());
        };
        this.state = {
            password: "",
            confirmPassword: ""
        };
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== null) {
            this.setState({
                password: nextProps.value,
                confirmPassword: nextProps.value
            });
        }
    }
    render() {
        return (React.createElement("div", null,
            React.createElement(PasswordInput_1.PasswordInput, { value: this.state.password, onInputChange: (data) => this.passwordFieldChange("password", data), disabled: this.props.disabled, placeholder: "Password", showStrength: this.props.showStrength }),
            React.createElement(PasswordInput_1.PasswordInput, { value: this.state.confirmPassword, onInputChange: (data) => this.passwordFieldChange("confirmPassword", data), disabled: this.props.disabled, placeholder: "Confirm password" })));
    }
}
exports.PasswordConfirmInput = PasswordConfirmInput;
//# sourceMappingURL=index.js.map